import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { selectors as OrganizationSelectors } from 'data/organizations'

import { dataFetched, makesSubscriptions } from 'data/graphql'
import { signOut as signOutAction } from 'data/auth/actions'

import {
  userPresenceFragment,
  userAttrsFragment,
  userPreferencesAttrsFragment,
} from 'remote/users'

import { organizationPermissionsAttrsFragment } from 'remote/organizations'

const userPreferencesUpdatedSubscription = gql`
  subscription userPreferencesUpdated($organizationId: ID!) {
    userPreferencesUpdated(organizationId: $organizationId) {
      ...userPreferencesAttrs
    }
  }
  ${userPreferencesAttrsFragment}
`

const userCreatedSubscription = gql`
  subscription userCreated($organizationId: ID!) {
    userCreated(organizationId: $organizationId) {
      ...userAttrs
    }
  }
  ${userAttrsFragment}
`

const userUpdatedSubscription = gql`
  subscription userUpdated($organizationId: ID!) {
    userUpdated(organizationId: $organizationId) {
      ...userAttrs
      organization {
        __typename
        id
        permissions {
          ...organizationPermissionsAttrs
        }
      }
    }
  }
  ${userAttrsFragment}
  ${organizationPermissionsAttrsFragment}
`

const userPresenceUpdatedSubscription = gql`
  subscription userPresenceUpdated($organizationId: ID!) {
    userPresenceUpdated(organizationId: $organizationId) {
      ...userPresence
    }
  }
  ${userPresenceFragment}
`

const userSignsOutSubscription = gql`
  subscription onSignOut($organizationId: ID!) {
    onSignOut(organizationId: $organizationId) {
      removeTokens
    }
  }
`

const providesUsersSubscriptions = compose(
  connect(
    state => ({
      organizationId: OrganizationSelectors.getOrganizationId(state),
    }),
    { dataFetched, signOut: signOutAction }
  ),
  makesSubscriptions({
    query: userPreferencesUpdatedSubscription,
    mapPropsToVariables: ({ organizationId }) => ({ organizationId }),
    getOnResultFromProps: ({ dataFetched }) => ({ result, meta }) => {
      dataFetched(result.data.userPreferencesUpdated, meta)
    },
  }),
  makesSubscriptions({
    query: userUpdatedSubscription,
    mapPropsToVariables: ({ organizationId }) => ({ organizationId }),
    getOnResultFromProps: ({ dataFetched }) => ({ result, meta }) => {
      dataFetched(result.data.userUpdated, meta)
    },
  }),
  makesSubscriptions({
    query: userCreatedSubscription,
    mapPropsToVariables: ({ organizationId }) => ({ organizationId }),
    getOnResultFromProps: ({ dataFetched }) => ({ result, meta }) => {
      dataFetched(result.data.userCreated, meta)
    },
  }),
  makesSubscriptions({
    query: userPresenceUpdatedSubscription,
    mapPropsToVariables: ({ organizationId }) => ({ organizationId }),
    getOnResultFromProps: ({ dataFetched }) => ({ result, meta }) => {
      dataFetched(result.data.userPresenceUpdated, meta)
    },
  }),
  makesSubscriptions({
    query: userSignsOutSubscription,
    mapPropsToVariables: ({ organizationId }) => ({ organizationId }),
    getOnResultFromProps: ({ signOut }) => ({ result }) => {
      signOut({ removeTokens: result.data.onSignOut.removeTokens })
    },
  })
)

export default providesUsersSubscriptions
